import React from 'react';
import { faExclamationCircle, faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BoldSmallBodyText, Header5Text, SmallBodyText, SpacerRow, Tooltip } from 'ui-toolkit';
import styled from 'styled-components';

export interface IAvailableBalanceLabelProps {}

const BoldSmallBodyTextSpan = styled.span`
  ${(props) => props.theme.fonts.mixins.boldSmall}
`;

export const AvailableBalanceMoneyLabel: React.FC<IAvailableBalanceLabelProps> = () => {
  return (
    <Tooltip
      placement={'bottom'}
      tooltipContent={
        <>
          <BoldSmallBodyText>What is this?</BoldSmallBodyText>
          <SmallBodyText>
            This represents the current available balance tied to this order that Spruce is holding in escrow.
            <br />
            This considers outgoing transactions that have been send but not yet cleared.
          </SmallBodyText>
          <SpacerRow />
          <BoldSmallBodyText>How is it calculated?</BoldSmallBodyText>
          <SmallBodyText>
            This is the sum of all transactions matched to this order less{' '}
            <BoldSmallBodyTextSpan>pending</BoldSmallBodyTextSpan> disbursements.
          </SmallBodyText>
          <SpacerRow />
          <SmallBodyText>
            <FontAwesomeIcon icon={faExclamationCircle} /> This number will be incorrect if you’ve sent funds and have
            not yet matched incoming funds to the order.
          </SmallBodyText>
        </>
      }
    >
      <div className={'flex flex-row gap-1 items-center'}>
        <Header5Text>Available</Header5Text>
        <FontAwesomeIcon icon={faQuestionCircle} />
      </div>
    </Tooltip>
  );
};
